import React from "react";
import Popover from "@mui/material/Popover";
import { Card, CardContent, Box, CardActions } from "@mui/material";
import "./FilterCommonStatusSelect.scss";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { styled } from "@mui/system";
import moment from "moment";
import Badge from "@mui/material/Badge";
import { useNavigate } from "react-router-dom";
import { ORG_ID } from "../../../constant/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LMS_MARKET } from "../../../constant/routeContant";

const NotificationList = ({
  id,
  open,
  anchorEl,
  handleClose,
  NotifiactionListDatas,
  UpdateNotifiactionListData,
}) => {
  const navigate = useNavigate();
  const StyledPopover = styled(Popover)({
    "& .MuiPaper-root": {
      maxHeight: 400,
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "12px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        borderRadius: "0px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#eee",
      },
    },
  });
  const cardClickHandler = async (item) => {
    const data = {
      notificationId: [item?.notificationId],
      status: 1,
    };
    const isScormFromUrl = (url) => {
      if (!url) return false;
      const params = new URLSearchParams(url.split("?")[1]);
      return params.get("isscorm") === "True";
    };
    const shouldNavigateToScorm = isScormFromUrl(item?.browserUrl);

    if (parseInt(ORG_ID()) === item?.orgId) {
      try {
        await UpdateNotifiactionListData(data);
        handleClose();

        if (shouldNavigateToScorm) {
          navigate(LMS_MARKET, {
            state: {
              isNotiication: true,
            },
          });
        } else {
          navigate(item?.browserUrl, {
            state: {
              isNotiication: true,
            },
          });
        }
      } catch (error) {
        console.error("Error updating notification data:", error);
      }
    } else {
      localStorage.setItem("orgId", item.orgId);
      localStorage.setItem("divisionId", 0);
      localStorage.setItem("orgName", item.orgName);
      localStorage.setItem("orgLogo", item.orgLogo);
      localStorage.setItem("ProcoreCompanyId", item.procoreCompanyId);
      localStorage.setItem("IsProcoreConnected", item.procoreCompanyName);
      setTimeout(() => {
        toast("Organization Switched");
        if (shouldNavigateToScorm) {
          navigate(LMS_MARKET, {
            state: {
              isNotiication: true,
            },
          });
        } else {
          navigate(item?.browserUrl, {
            state: {
              isNotiication: true,
            },
          });
        }
      }, 3);
      handleClose();
    }
  };

  function formatDate(dateTimeString) {
    let dateTime = moment(dateTimeString);
    return dateTime.format("DD MMMM HH:mm");
  }

  return (
    <>
      <ToastContainer />
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Card className="filterlist_of_cases Notification-box">
          <CardContent>
            <Box
              className="custom_filter_box"
              sx={{
                width: 420,
                maxHeight: 500,
                pb: 2,
              }}
            >
              <div className="NotificationMainconatiner">
                <div className="NotificationHeading">Notifications</div>
                {NotifiactionListDatas?.notificationList?.map((item, index) => {
                  const isDisabled = item?.status === 2;
                  return (
                    <div
                      className={`notificationConatiner ${
                        isDisabled ? "notificationdisabe" : "notificationena"
                      }`}
                      key={index}
                      onClick={() => {
                        if (!isDisabled) {
                          cardClickHandler(item);
                        }
                      }}
                    >
                      <div className="bellicon">
                        <NotificationsIcon className="notificationIcon"></NotificationsIcon>
                      </div>
                      <div
                        className="notificationTextContainer"
                        style={{
                          fontWeight: item?.status === 0 ? "bold" : "normal",
                        }}
                      >
                        <div className="NotificationTitleContainer">
                          <div
                            className={`${
                              isDisabled ? "titleDisable" : "notificationTitle"
                            }`}
                          >
                            {item?.title}
                          </div>
                        </div>
                        <div className="notificationSubTitle">
                          {item?.description}
                        </div>
                        <div
                          className="notificationSubTitle"
                          style={{
                            fontWeight: "normal",
                          }}
                        >
                          {item?.orgName}
                        </div>
                      </div>
                      <div className="notificationDateTimeUnread">
                        <div
                          className="notificationDateTime"
                          style={{
                            fontWeight: item?.status === 0 ? "bold" : "normal",
                          }}
                        >
                          {formatDate(item?.createdOnDt)}{" "}
                        </div>
                        {item?.status === 0 && (
                          <div className="unreadDot">
                            <Badge color="primary" variant="dot"></Badge>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Box>
          </CardContent>
        </Card>
      </StyledPopover>
    </>
  );
};

export default NotificationList;
